export const tileRowGap = 5;

export const priceValuePropBackground = '#809054';

export const desktopAspectX = '3';
export const desktopAspectY = '5';
export const desktopAspect = `${desktopAspectX} / ${desktopAspectY}`;

export const mobileAspectX = '1';
export const mobileAspectY = '2';
export const mobileAspect = `${mobileAspectX} / ${mobileAspectY}`;

// Slightly shorter tile aspects for the hide-price treatment — reclaims the dead space
// where the price label used to sit. ValuePropCard also adopts these ratios when the
// treatment is active so all tiles in a row share the same height.
export const treatmentDesktopAspectX = '3.15';
export const treatmentDesktopAspectY = '4.5';
export const treatmentDesktopAspect = `${treatmentDesktopAspectX} / ${treatmentDesktopAspectY}`;

export const treatmentMobileAspectX = '1.05';
export const treatmentMobileAspectY = '1.8';
export const treatmentMobileAspect = `${treatmentMobileAspectX} / ${treatmentMobileAspectY}`;
